import React, { Component } from 'react';
import MaterialTable from 'material-table';


import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { withStyles } from '@material-ui/core/styles';
import Brightness1 from '@material-ui/icons/Brightness1';
import MenuTooltip from '../common/MenuTooltip';
import Alerta from '../common/Alerta';

import{ NODE_TYPE_COMPONENT,NODE_TYPE_DELIVERABLE,NODE_TYPE_WORKPACKAGE } from '../common/redux/constantes';

import moment from 'moment';

const styles = theme => ({
  button: {
    marginTop: theme.spacing.unit + 5,
    marginRight:'5px'
  },
  input: {
    display: 'none',
  },
});


class WorkStructureTable extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      tree : [],
      openAlerta:false,
      messageAlerta:""
    }
    this.getTreeFromParent = this.getTreeFromParent.bind(this);
    this.validateWBS = this.validateWBS.bind(this);
  }

  componentDidMount()
  {
  }

  getTreeFromParent(parent)
  {
      let tree = this.state.tree;
      let children;
      if(parent.children)
      {
        children = Object.create(parent.children);
        delete parent.children;
      }
      if(parent.due_date){
        parent.due_date = moment(parent.due_date).format("YYYY-MM-DD")
      }
      tree.push(parent);
      this.setState({tree:tree});
      if(children)
      {
        children.map(child=>{
          this.getTreeFromParent(child);
          return child;
        });
      }
  }

  validateWBS()
  {
    let valid = this.isNodeValid(this.state.tree[0]);
    if(!valid){
      this.setState({
        openAlerta:true,
        messageAlerta:"This table has some invalid components"
      })
    }else{
      this.setState({
        openAlerta:true,
        messageAlerta:"This table is valid"
      })
    }
  }
  
  isNodeValid(node)
  {
    if(node.tipo === NODE_TYPE_DELIVERABLE)
    {
      //Si el tipo del nodo es entregable y no encuentra un workpackage teniendolo como padre, entonces es inválido
      return this.state.tree.find(item => item.deliverable === node.id && item.tipo === NODE_TYPE_WORKPACKAGE);
    }
    else
    {
      if(node.tableData.childRows && node.tableData.childRows.length > 0)
      {
        //Si tiene varios hijos, hacemos que todos los hijos sean validos sino no es valido el actual componente.
        let valid = true;
        node.tableData.childRows.forEach(item=>{
          valid = valid && this.isNodeValid(item);
        });
        return valid;
      }
      else
      {
        //Si no tiene hijos entonces es inválido el componente.
        return false;
      }
    }
  }

  render() {
    return (
      <div>
        <MaterialTable
          title="Planning"
          data={query =>
            new Promise((resolve, reject) => {
              this.props.actions.fetchWbs(this.props.project.project)
              .then(res=>{
                this.getTreeFromParent(res.tree);
                resolve({
                  data:this.state.tree,
                  page: 0,
                  totalCount: this.state.tree.length
                });
              });
            })}
          columns={[
            { title: 'Name', field: 'name' },
            {
              title: 'Type',
              field: 'tipo',
              render: rowData => {
                if(rowData.tipo === NODE_TYPE_COMPONENT)
                {
                  return <div>Work Component<Brightness1 style={{color:"#616161",width: 40, borderRadius: '50%'}}/> </div>
                }else if(rowData.tipo === NODE_TYPE_DELIVERABLE)
                {
                  return <div>Deliverable<Brightness1 style={{color:"#000",width: 40, borderRadius: '50%'}}/> </div>
                }else if(rowData.tipo === NODE_TYPE_WORKPACKAGE)
                {
                  return <div>Work Package<Brightness1 style={{color:"#00ACC1",width: 40, borderRadius: '50%'}}/> </div>
                }
              }
            },
            { title: 'Description', field: 'description' },
            {
              title:'Status',
              render: rowData=>
              {
                if(rowData.tipo !== NODE_TYPE_WORKPACKAGE && !this.isNodeValid(rowData))
                {
                    return <div>Invalid <Brightness1 style={{color:"#ff401e",width: 40, borderRadius: '50%'}}/></div>
                }
                else
                {
                  return <div>Valid <Brightness1 style={{color:"#40bd84",width: 40, borderRadius: '50%'}}/> </div>
                }
              }
            }
          ]}
          parentChildData={(row, rows) => {
            if(row.tipo === 3)
            {
              return rows.find(a=> a.id === row.deliverable && a.tipo === 2);
            }
            else if(row.tipo === 1)
            {
                return rows.find(a=> a.id === row.component_father && a.tipo === 1);
            }
            else if(row.tipo === 2)
            {
              return rows.find(a=> a.id === row.component && a.tipo === 1);
            }
            else{
              return false;
            }
          }}
          options={{
            search:false,
            sorting:false,
            maxBodyHeight:"600px",
          }}
          components={{
            Pagination: props=>(null)
          }}
        />
        <MenuTooltip validateWBS={this.validateWBS} validate={false} close={true}/>
        <Alerta 
          message={this.state.messageAlerta} 
          openAlert={this.state.openAlerta} 
          closeErrorDialog={()=>this.setState({openAlerta:false, messageAlerta:""})}/>
      </div>
    )
  }
}


/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    wbs: state.wbs,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}


WorkStructureTable.propTypes = {
};

export default 
connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(WorkStructureTable));


// WEBPACK FOOTER //
// ./src/features/wbs/WorkStructureTable.js